import { signal, WritableSignal } from '@angular/core';
import { ControlConfig } from '../../../models/api/reports/report';
import { ValidatorsEx } from '../../../validators/validators-ex';

export class SharedControlConfigs {
  static createAsOfDateConfig(
    visibility: WritableSignal<boolean> = signal(false),
  ): ControlConfig {
    return {
      erfNames: 'AS_OF_DATE',
      formControlName: 'asOfDate',
      visibility,
      type: 'date',
    };
  }

  static createComparedWithAsOfDateConfig(
    visibility: WritableSignal<boolean> = signal(false),
  ): ControlConfig {
    return {
      erfNames: 'COMPARED_WITH_AS_OF_DATE',
      formControlName: 'comparedWithAsOfDate',
      visibility,
      type: 'date',
    };
  }

  /** @param toVisibility - Can be same signal as fromVisibility */
  static createTransactionDateRangeConfigs(
    fromVisibility: WritableSignal<boolean> = signal(false),
    toVisibility: WritableSignal<boolean> = signal(false),
  ): ControlConfig[] {
    return [
      {
        erfNames: 'TRANSACTION_FROM_DATE',
        formControlName: 'transactionFromDate',
        visibility: fromVisibility,
        type: 'date',
      },
      {
        erfNames: 'TRANSACTION_TO_DATE',
        formControlName: 'transactionToDate',
        visibility: toVisibility,
        type: 'date',
      },
    ];
  }

  static createPaymentTypeConfig(
    visibility: WritableSignal<boolean> = signal(false),
  ): ControlConfig {
    return {
      erfNames: ['INCLUDE_THESE_PAYMENT_TYPES', 'PAYMENT_TYPES'],
      formControlName: 'paymentType',
      visibility,
      type: 'multiselect',
      defaultOptionCode: 'ALL',
    };
  }

  static createDocumentTypeConfig(
    visibility: WritableSignal<boolean> = signal(false),
  ): ControlConfig {
    return {
      erfNames: [
        'INCLUDE_THESE_DOCUMENT_TYPES',
        'INCLUDE_DOCUMENT_TYPES_AUTH',
        'DOCUMENT_TYPE',
      ],
      formControlName: 'documentType',
      visibility,
      type: 'multiselect',
    };
  }

  static createPaymentStatusConfig(
    visibility: WritableSignal<boolean> = signal(false),
  ): ControlConfig {
    return {
      erfNames: ['INCLUDE_VOIDS'],
      formControlName: 'clearedStatus',
      visibility,
      defaultOptionCode: 'ALL',
    };
  }

  static createPayeeNameConfig(
    visibility: WritableSignal<boolean> = signal(false),
  ): ControlConfig {
    return {
      erfNames: 'PAYEE_NAME',
      formControlName: 'payeeName',
      visibility,
      type: 'string',
      validators: [ValidatorsEx.alphaNumeric()],
    };
  }

  static createCurrencyConfig(
    erfName: string,
    formControlName: string,
    visibility: WritableSignal<boolean> = signal(false),
  ): ControlConfig {
    return {
      erfNames: erfName,
      formControlName,
      visibility,
      type: 'currency',
    };
  }

  static createRadioButtonConfig(
    erfName: string,
    formControlName: string,
    visibility: WritableSignal<boolean> = signal(false),
  ): ControlConfig {
    return {
      erfNames: erfName,
      formControlName,
      visibility,
      defaultToFirstOption: true,
    };
  }

  static createNumberConfig(
    erfName: string,
    formControlName: string,
    visibility: WritableSignal<boolean> = signal(false),
  ): ControlConfig {
    return {
      erfNames: erfName,
      formControlName,
      visibility,
      type: 'number',
    };
  }

  static createIncludeAtUnitLevelConfig(
    visibility: WritableSignal<boolean> = signal(false),
  ): ControlConfig {
    return {
      erfNames: 'INCLUDE_AT_UNIT_LEVEL',
      formControlName: 'includeAtUnitLevel',
      visibility,
      type: 'multiselect',
    };
  }
}
